import {Component, Prop, Vue} from "vue-property-decorator";
import * as _ from 'lodash'
import {Button, ButtonGroup} from 'kpc/components/button';

import Icon from 'kpc/components/icon';
import {debounce} from "helpful-decorators";

const states = {
    normal: 'normal',
    edit: 'edit'
}

@Component({
    components: {
        Icon,
        Button
    }
})
export default class TableColumnEdit extends Vue {

    state: string = states.normal
    editValue:string = ''

    @Prop({
        default: ''
    })
    value!: string

    get isNormalState() {
        return this.state === states.normal;
    }

    get isEditState() {
        return this.state === states.edit;
    }

    linkClick() {
        this.$emit('link', {
            row: this.rowScope
        })
    }

    edit() {
        this.editValue = this.value;
        this.state = states.edit
    }

    valueHandler() {
        if (this.state !== states.edit) {
            return;
        }
        this.state = states.normal;
        let editValue = _.trim(this.editValue);
        if (editValue === '' || editValue === this.value) {
        } else {
            this.$emit('change', editValue);
        }
    }

    valueReset() {
        this.state = states.normal
    }

}
